import { Component,  OnInit } from '@angular/core';
import { ConfService } from 'src/conf.service';
import { DynamicDialogConfig,DynamicDialogRef } from 'primeng/dynamicdialog';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { UserAction } from 'src/app/enum/user/userActions';
import { LabRequestDetail,  LabResult, UserLocationFacility } from 'src/app/models';
import { AccessUserInfo, UserDetail } from 'src/app/models/user/UserInfo';
import { LoaderService } from 'src/app/services/loader.service';
import { UserService } from 'src/app/services/user.service';
import { LabRequestService } from 'src/app/services/water-lab/lab-request.service';

@Component({
  selector: 'bart-lab-request-history',
  templateUrl: './lab-request-history.component.html',
  styleUrls: ['./lab-request-history.component.scss'],
 
})
export class LabRequestHistoryComponent implements OnInit {
  public userInfo: UserDetail;
  public currentRequest:LabRequestDetail;
  labRequestId?:number;
  public styleName:string="";
  public useExistingCss:boolean=true;
  selectedFacilityDisplayName:string;
  selectedFacilityMasterId : number= null;
  userLocationFacilities :UserLocationFacility []= [];
  selectLabResultRow:LabResult[]=[];
  labResultColumn:any[];
  isFromLabResultPage:boolean=false
  printPDF:boolean=false;
  startDate: string;
  endDate: string;
  labResultsPrint: LabResult[]=[];
  labResults:  LabResult[]=[];
  isDateRangeDisplay: boolean = false;
  constructor(private _waterLabService: LabRequestService, private _loaderService: LoaderService,private _dynamicDialogRef: DynamicDialogRef,
    private dynamicConfig : DynamicDialogConfig,private _userService:UserService) { }

  ngOnInit() 
  {
    this.applyPrintCSSForProductionBuild();
     this.userInfo = AccessUserInfo.getUserInfo();
     this.labRequestId = this.dynamicConfig.data.labRequestId
     this.selectedFacilityDisplayName=this.dynamicConfig.data.facilityDisplayName;
     this.selectedFacilityMasterId=this.dynamicConfig.data.selectedFacilityMasterId;
     this.userLocationFacilities=this.dynamicConfig.data.userLocationFacilities;
     this.isFromLabResultPage=this.dynamicConfig.data.isFromLabResultPage;
    this.getLabRequestDetails();
    this.labResultColumn =
    [
      { field: 'LabRequisitionNumber', header: 'REQUISITION ID', display: 'table-cell', width: "15%" },
      { field: 'TestDisplayName', header: 'TEST ID | NAME', display: 'table-cell', width: "15%" },
      { field: 'EquipmentDisplayName', header: 'MODEL # | SERIAL # | EQUIPMENT ID', display: 'table-cell', width: "24%" },
      { field: 'LabResult', header: 'RESULT | UNIT', display: 'table-cell', width: "14%" },
      { field: 'Status', header: 'STATUS', display: 'table-cell', width: "13%" },
      { field: 'DrawDate', header: 'DRAW DATE', display: 'table-cell', width: "13%" },
      { field: 'LabComments', header: 'LAB COMMENTS', display: 'table-cell', width: "16%" }
    ];
  }
  getLabRequestDetails()
  {
    this._loaderService.show()
    let historyRequestParam={
      GETLABREQUESTDETAIL: {
        LabRequestID:this.labRequestId 
    }
    }
    this._waterLabService.getLabRequestDetails(historyRequestParam).subscribe((data)=>
    {
      if(data.labRequestDetails)
      {
        this.currentRequest=data.labRequestDetails[0];
        this.currentRequest.LabTests=JSON.parse(this.currentRequest.LabTestsJson)
      }
      this._loaderService.hide()
    },
    (err) => 
    {
      this._loaderService.hide()
      console.log("Error While getting Lab Request History");
    });   
    
}

 
  closePopup() {
    this._dynamicDialogRef.destroy();
    //#region User Action Audit
    this._userService.logUserAction({
      userName:this.userInfo.userName,
      userAction:UserAction.BUTTON_CLICKED,
      screenName:ScreenName.LABREQUEST_HISTORY,
      screenPath:location.pathname,
      key:'LabRequestID',
      value:this.labRequestId.toString(),
      eventDescription:this.isFromLabResultPage?UserActionDescription.LAB_RESULTS_LAB_REQUEST_HISTORY_POPUP_CLOSE_CLICKED: UserActionDescription.LABREQUEST_HISTORY_POPUP_CLOSE_CLICKED
    }); 
    //#endregion
  }
  logAuditOnPrint() {
    //#region User Action Audit
    this._userService.logUserAction({
      userName:this.userInfo.userName,
      userAction:UserAction.BUTTON_CLICKED,
      screenName:ScreenName.LABREQUEST_HISTORY,
      screenPath:location.pathname,
      key:'LabRequestID',
      value:this.labRequestId.toString(),
      eventDescription:this.isFromLabResultPage?UserActionDescription.LAB_RESULTS_LAB_REQUEST_HISTORY_POPUP_PRINT_CLICKED: UserActionDescription.LABREQUEST_HISTORY_POPUP_PRINT_CLICKED
    }); 
    //#endregion
  }
  public applyPrintCSSForProductionBuild()
  {
    
    this.useExistingCss=true;
    if (ConfService.conf.environment.production) {
      this.useExistingCss = false;
      const elements = document.getElementsByTagName('link');
      for (let index = 0; index < elements.length; index++) {
        console.log(elements[index].href);
        //if (elements[index].href.startsWith(document.baseURI)) {
          this.styleName += elements[index].href + ',';
        //}
      }
      this.styleName = this.styleName.slice(0, -1);
    }

    
    
  }
  printLabResultPDF()
  {
    this._loaderService.show();
    this.printPDF=true;
  }
  printPDFLoaded()
  {
    this.printPDF=false; 
    this._loaderService.hide();     
  } 
  
  getLabResults(event){
    this.labResultsPrint= []
    this.labResults = event;
    this.labResults.forEach(item=>
      {
        if(item.IsProfile == true){
          let objTests=item.LabProfileTests;
          objTests.forEach(x=>
            { 
              
               let objLabResult : any  = {};
              objLabResult.LabRequisitionID  =item.LabRequisitionID       
              objLabResult.LabRequisitionNumber  =item.LabRequisitionNumber   
              objLabResult.TestDisplayName=x.TestDisplayName		  
              objLabResult.EquipmentDisplayName=item.EquipmentDisplayName     
              objLabResult.LabResult =x.TestResult            
              objLabResult.LabRange=x.LabRange
              objLabResult.LabComments=x.LabComments
              objLabResult.Status=x.LabResultStatus
              objLabResult.IsProfile=item.IsProfile
              objLabResult.DrawDate=item.DrawDate
              objLabResult.LabRequestID=item.LabRequestID
              objLabResult.IsRedraw=item.IsRedraw
              objLabResult.ReDrawStatus=item.ReDrawStatus
              objLabResult.ShippingDate=item.ShippingDate
              this.labResultsPrint.push(objLabResult)
            });
        }
        else{
            this.labResultsPrint.push(item)
         }
      });

  }
}
